// Mock data for Rezvani Furniture Studio

export const products = [
  {
    id: '1',
    name: 'Tenjam Shayz Lounge Chair Set',
    category: 'lounge-chairs',
    price: 1604.99,
    rating: 4.8,
    reviews: 144,
    image: 'https://images.unsplash.com/photo-1581404649902-bb9eda7473e4?w=800&q=80',
    description: 'In Pool Lounge Chairs for Sun Shelf Set of Two. Custom Designed Risers Support up to 17" of Water Depth.',
    features: ['Custom Colors Available', 'Made-to-Order', 'UV Resistant', 'Rust-Proof Hardware'],
    colors: ['White Granite', 'Gray Granite', 'Beige', 'Custom'],
    waterDepth: '17 inches',
    inStock: true,
  },
  {
    id: '2',
    name: 'Tenjam Freelo Lounge Chair',
    category: 'lounge-chairs',
    price: 499.99,
    rating: 4.9,
    reviews: 22,
    image: 'https://images.unsplash.com/photo-1566665797739-1674de7a421a?w=800&q=80',
    description: 'In Pool Lounge Chair for Sun Shelf. Pool Chairs and Lounger for Tanning Ledge Support up to 11" of Water Depth.',
    features: ['Made-to-Order', 'Weather Resistant', 'Easy Assembly', 'Premium Materials'],
    colors: ['White', 'Gray', 'Beige'],
    waterDepth: '11 inches',
    inStock: true,
  },
  {
    id: '3',
    name: 'Tenjam Moon Chair Set',
    category: 'lounge-chairs',
    price: 1519.98,
    rating: 4.9,
    reviews: 37,
    image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80',
    description: 'In Pool Lounge Chairs for Sun Shelf Set of Two. Designed for in Pool Tanning Ledge Support up to 12" of Water Depth.',
    features: ['Ergonomic Design', 'Custom Colors', 'Heavy Duty', 'Low Maintenance'],
    colors: ['White Granite', 'Gray Granite', 'Custom Colors'],
    waterDepth: '12 inches',
    inStock: true,
  },
  {
    id: '4',
    name: 'Tenjam Woosah Adirondack Chair',
    category: 'lounge-chairs',
    price: 1799.99,
    rating: 4.5,
    reviews: 9,
    image: 'https://images.unsplash.com/photo-1615529182904-14819c35db37?w=800&q=80',
    description: 'Adirondack Chair for in Pool. Lounge Chairs for Sun Shelf Set of Two Support up to 13" of Water Depth.',
    features: ['Classic Design', 'Made-to-Order', 'Premium Finish', 'All-Weather'],
    colors: ['White', 'Gray', 'Natural'],
    waterDepth: '13 inches',
    inStock: true,
  },
  {
    id: '5',
    name: 'Tenjam Laylo Lounge Set',
    category: 'lounge-chairs',
    price: 1199.98,
    rating: 4.8,
    reviews: 24,
    image: 'https://images.unsplash.com/photo-1589571894960-20bbe2828d0a?w=800&q=80',
    description: 'In Pool Lounge Chairs for Sun Shelf Set of Two with Optional Risers Support up to 22" of Water Depth.',
    features: ['Adjustable Height', 'Extra Deep Support', 'Weather Resistant', 'Easy Installation'],
    colors: ['White Granite', 'Beige', 'Gray'],
    waterDepth: '22 inches',
    inStock: true,
  },
  {
    id: '6',
    name: 'Tenjam Ripple Side Table',
    category: 'tables',
    price: 249.99,
    rating: 3.8,
    reviews: 13,
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
    description: 'In Pool Lounger Side Table for Sun Shelf. Ledge Table for Water Depths up to 10".',
    features: ['Compact Design', 'Built-in Cup Holders', 'Durable Material', 'Multiple Colors'],
    colors: ['White', 'Gray Granite', 'White Granite'],
    waterDepth: '10 inches',
    inStock: true,
  },
  {
    id: '7',
    name: 'Tenjam Ripple Wide Table',
    category: 'tables',
    price: 474.99,
    rating: 5.0,
    reviews: 4,
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
    description: 'In Pool Table with Umbrella Hole for Sun Shelf. Ledge Table for Water Depths up to 10".',
    features: ['Umbrella Hole', 'Wide Surface', 'Made-to-Order Colors', 'Heavy Duty'],
    colors: ['White', 'Gray', 'Custom'],
    waterDepth: '10 inches',
    inStock: true,
  },
  {
    id: '8',
    name: 'Tenjam Mibster Chair Set',
    category: 'lounge-chairs',
    price: 1519.98,
    rating: 5.0,
    reviews: 3,
    image: 'https://images.unsplash.com/photo-1601276683756-31232958a49c?w=800&q=80',
    description: 'Chair in Pool Lounge Chairs for Sun Shelf Set of Two Support up to 12" of Water Depth.',
    features: ['Modern Design', 'New White Granite', 'Comfortable', 'Premium Quality'],
    colors: ['White Granite', 'Gray', 'Custom'],
    waterDepth: '12 inches',
    inStock: true,
  },
  {
    id: '9',
    name: 'Tenjam Drift Splash Stool Set',
    category: 'stools',
    price: 479.98,
    rating: 4.5,
    reviews: 8,
    image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=800&q=80',
    description: 'Splash Series in Pool Stools for Sun Shelf Set of 2. Ledge Table for Water Depths up to 7".',
    features: ['Set of 2', 'Compact', 'Lightweight', 'Durable'],
    colors: ['White Granite', 'Gray', 'Beige'],
    waterDepth: '7 inches',
    inStock: true,
  },
  {
    id: '10',
    name: 'Tenjam Dash Bench',
    category: 'benches',
    price: 569.99,
    rating: 4.7,
    reviews: 6,
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80',
    description: 'Bench with Umbrella Hole for Sun Shelf. Ledge Table for Water Depths up to 10".',
    features: ['Umbrella Compatible', 'Spacious Seating', 'Weather Resistant', 'Premium Finish'],
    colors: ['White Granite', 'Gray', 'Beige'],
    waterDepth: '10 inches',
    inStock: true,
  },
];

export const categories = [
  {
    id: 'loungers',
    name: 'Loungers',
    description: 'Premium in-pool loungers for ultimate relaxation',
    images: [
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/6lvukhsz_Shayz%20Lounger%20White%20Granite%20-%2027.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/p7dqnar4_SPL33100WH%20Shayz%20-%202%20units%20in%20pool%20-%20sunset%20image%201.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/kca6daec_SPL33100WH%20Shayz%20-%20Comfort%20image%201.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/tnmyfq7m_Blue%20Square%20Borg%20Res-1-2.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/zbej1dns_Shayz%20Lounger%20White%20Granite%20-%2021.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/cg0ynokg_Tenjam%20Shayz%20in-pool%20Lounger%20with%20Ripple%20Wide%20Table%20-%20Horizontal.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/2nfdlqps_Tenjam%20Shayz%20Pillow%2C%20Aqua%20-%20AQ%2C%20Image%201.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/z59sh5n8_Tenjam%20Shayz%2C%20White%20Granite%2C%20Overhead%20Image%203.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/y14nl81u_SPL33100WH%20Shayz%20-%20Comfort%20image%20with%208in%20Risers%20-%20Image%203.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/r6r64wti_SPL33100WH_%20Shayz%20-%20Lounger%20in%20Pool%201.png',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/8wmpkbfo_tenjam-280.jpg'
    ],
    image: 'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/6lvukhsz_Shayz%20Lounger%20White%20Granite%20-%2027.jpg',
  },
  {
    id: 'chairs',
    name: 'Chairs',
    description: 'Stylish and comfortable pool chairs',
    images: [
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/9px9papo_WOOCBASEBLSEATWH%20%20Woosah%20Chair%20with%20Amped%20table%20-%201%20chair%20and%201%20table.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/syphdij3_%2322103BXYE%20Mibster%20Chairs%20and%20%2322101T1YE%20Amped%20Seat%20Table%20on%20Patio%20-%20image%201.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/2plp1adc_Amped%20Table%20and%20Freelo%20Chair%20in%20Surf%20Blue%20on%20Patio.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/vtor5d9x_Amped%20Table%20and%20Freelo%20Chair%20in%20Yellow%20in%20pool.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/fubyz5r2_Freelo%20Chair%20and%20Amped%20table%20around%20a%20firepit%20on%20beach.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/m7pyh4xg_WOOCBASEBLSEATWH%20%20Woosah%20Chair%20with%20Splash%20Amped%20table%20-%201%20chairs%20water%20in%20back.jpg'
    ],
    image: 'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/9px9papo_WOOCBASEBLSEATWH%20%20Woosah%20Chair%20with%20Amped%20table%20-%201%20chair%20and%201%20table.jpg',
  },
  {
    id: 'stools-benches',
    name: 'Stools and Benches',
    description: 'Versatile seating for shallow water areas',
    images: [
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/uq2o7yg7_Tenjam%20Drift%20Stool%20-%20Image%206.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/p66e408q_SPL11501BXYE%20Drift%20in%20pool%20%231.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/irz66ylu_SPL11501BXYE%20Drift%20on%20patio%20%233.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/i92e5qxi_Tenjam%20Drift%20Stool%20-%20Image%204.jpg'
    ],
    image: 'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/uq2o7yg7_Tenjam%20Drift%20Stool%20-%20Image%206.jpg',
  },
  {
    id: 'tables',
    name: 'Tables',
    description: 'Convenient side tables for your pool lounge area',
    images: [
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/87kqi4vi__MG_9185_Final_High_Rez_Tenjam_Jupiter_2025_SPLASH_Robert%20Holland.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/uoeulc4l_%2322101T1YE%20amped%20Seat%20Table%201%20unit%20in%20pool%20-%20image%201.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/pp72hkpz_%2322101T1YE%20amped%20Seat%20Table%201%20unit%20in%20pool%20-%20image%204.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/947o9xvg_%2322103BXYE%20Mibster%20Chairs%20and%20%2322101T1YE%20Amped%20Seat%20Table%20on%20Patio%20-%20image%201.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/65fb0uxk__MG_9108_Final_High_Rez_Tenjam_Jupiter_2025_SPLASH_Robert%20Holland.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/ffd1el2x_Tenjam%20Shayz%20in-pool%20Lounger%20with%20Ripple%20Wide%20Table%20-%20Horizontal.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/tbnox63q_Amped%20Table%20and%20Freelo%20Chair%20in%20Surf%20Blue%20on%20Patio.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/ckal992y_Amped%20Table%20and%20Freelo%20Chair%20in%20Yellow%20in%20pool.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/wjt07l6q_SPL22101T1WHWH%20%20Splash%20Amped%20seat%20and%20Table%20in%20White%20with%20White%20Cupholders.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/7d0am1u1_SPLRWIDETABLEWG%20Tenjam%20Splash%20Ripple%20Wide%20Table%2C%20White%20Granite.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/bgqcsduf_Tenjam%20Splash%20Amped%20Table%2C%20White%20Granite%2C%20Image%202.jpg',
      'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/jftjp4jz_WOOCBASEBLSEATWH%20%20Woosah%20Chair%20with%20Amped%20table%20-%201%20chair%20and%201%20table.jpg'
    ],
    image: 'https://customer-assets.emergentagent.com/job_furniture-studio-3/artifacts/87kqi4vi__MG_9185_Final_High_Rez_Tenjam_Jupiter_2025_SPLASH_Robert%20Holland.jpg',
  },
  {
    id: 'umbrellas',
    name: 'Umbrellas',
    description: 'Stylish shade solutions for your pool',
    image: 'https://images.unsplash.com/photo-1589571894960-20bbe2828d0a?w=600&q=80',
  },
  {
    id: 'planters',
    name: 'Planters',
    description: 'Beautiful planters to enhance your pool area',
    image: 'https://images.unsplash.com/photo-1615529182904-14819c35db37?w=600&q=80',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    description: 'Complete your pool setup with premium accessories',
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=600&q=80',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    location: 'Miami, FL',
    rating: 5,
    text: 'These lounge chairs transformed our pool area into a luxury resort! The quality is outstanding and they look absolutely stunning.',
    image: 'https://i.pravatar.cc/150?img=1',
  },
  {
    id: 2,
    name: 'Michael Chen',
    location: 'Los Angeles, CA',
    rating: 5,
    text: 'Worth every penny! The custom color options allowed us to match our pool perfectly. Highly recommend Rezvani Furniture.',
    image: 'https://i.pravatar.cc/150?img=33',
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    location: 'Chandler, AZ',
    rating: 5,
    text: 'Excellent craftsmanship and customer service. The Tenjam Moon Chairs are incredibly comfortable and durable.',
    image: 'https://i.pravatar.cc/150?img=5',
  },
  {
    id: 4,
    name: 'David Thompson',
    location: 'Houston, TX',
    rating: 4,
    text: 'Beautiful furniture that has held up perfectly through harsh Texas weather. Installation was straightforward.',
    image: 'https://i.pravatar.cc/150?img=12',
  },
];

export const featuredProducts = products.filter(p => [1, 2, 3, 6].includes(parseInt(p.id)));
